/**
 * AetherCSS-inspired refraction filter, defined once for all glass surfaces.
 * Only decorative pseudo-elements use this filter: text/icons/links stay crisp.
 * The fixed noise parameters mirror the supplied design reference.
 */
export function LiquidGlassFilter() {
  return (
    <svg className="liquid-glass-filter-defs" width="0" height="0" aria-hidden="true" focusable="false">
      <defs>
        <filter id="glass-distortion" x="0%" y="0%" width="100%" height="100%">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.025 0.025"
            numOctaves="2"
            seed="92"
            result="noise"
          />
          <feGaussianBlur in="noise" stdDeviation="2" result="blurred" />
          <feDisplacementMap
            in="SourceGraphic"
            in2="blurred"
            scale="65"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </defs>
    </svg>
  )
}
